/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { Field } from "@base-ui-components/react/field";
import { Select } from "@base-ui-components/react/select";
import { TimeHelper, useConfigurationSelector } from "@bms/common";
import React from "react";
import { useTranslation } from "react-i18next";

import ChevronDown from "resources/icons/chevron-down.svg";

import "./LanguageSelect.scss";

export const LanguageSelect = () => {
  const configuration = useConfigurationSelector();
  const { i18n, t } = useTranslation();

  const languages = configuration?.Languages ?? [];
  const items = languages.reduce<Record<string, string>>((acc, lang) => {
    acc[lang.Code] = lang.Name;
    return acc;
  }, {});

  return (
    <Field.Root>
      <Field.Label className="sr-only">
        {t("SETTINGS_PREFERENCES__LANGUAGE")}
      </Field.Label>
      <Select.Root
        value={i18n.language}
        items={items}
        onValueChange={async (value) => {
          await TimeHelper.setLanguage(value);
          await i18n.changeLanguage(value);
        }}
      >
        <Select.Trigger className="LanguageSelect">
          <Select.Value />
          <Select.Icon className="LanguageSelect__icon">
            <ChevronDown aria-hidden="true" />
          </Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Positioner
            className="LanguageSelect__positioner"
            alignItemWithTrigger={false}
          >
            <Select.Popup className="LanguageSelect__popup">
              {languages.map((lang) => (
                <Select.Item
                  key={lang.Code}
                  value={lang.Code}
                  className="LanguageSelect__item"
                >
                  <Select.ItemText>{lang.Name}</Select.ItemText>
                </Select.Item>
              ))}
            </Select.Popup>
          </Select.Positioner>
        </Select.Portal>
      </Select.Root>
    </Field.Root>
  );
};
